module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/mv_photowedding_01-8c6aa4a490b57a8da5c9d34a1dd5bd04.webp";